'use client';

import { useStore } from '@/store/store';
import { getText } from '@/utils/text/text';
import dayjs from 'dayjs';
import type { FC } from 'react';

export type LogoutPopClientProps = {
    logoAlt: string;
    logoUrl: string;
    header: string;
    body: string;
    link: string;
    linkText?: string;
    bodySecond?: string;
    buttonTitle: string;
    footer: string;
};

export const LogoutPopClient: FC<LogoutPopClientProps> = ({
    logoUrl,
    logoAlt,
    header,
    body,
    linkText,
    bodySecond,
    buttonTitle,
    footer
}) => {
    const { closePopup } = useStore((state) => state.popup);
    const lastLogin = useStore((state) => state.userContext?.session?.lastLogin);
    const handleShowLoading = useStore((s) => s.loading.handleShowLoading);
    const sessionTime = useStore((s) => s.timer.sessionTime);

    const onClose = () => {
        closePopup();
        handleShowLoading();
        window.location.assign('/');
    };

    const handleResponsibleGaming = async () => {
        await (
            await import('@fanduel/cpe-um-bundle/responsible-gaming/library')
        ).ResponsibleGaming.presentResponsiblePlaySettingsAsync(undefined, true, true);
    };

    const renderLastLogin = () => {
        const label = getText({ text: 'common.lastLogin' });
        const format = getText({ text: 'components.accountDetails.lastLoginDateFormat' });
        return `${label}: ${!!lastLogin ? dayjs(lastLogin).format(format) : '-'}`;
    };

    return (
        <div className="dialog">
            <div className="logo">
                <img src={logoUrl} alt={logoAlt} />
            </div>
            <div className="card__container">
                <div className="card__headline">{header}</div>
                <div className="card__text">
                    {body}
                    <span>
                        {linkText && (
                            <span className="like-link" onClick={handleResponsibleGaming}>
                                {linkText}
                            </span>
                        )}
                        {bodySecond}
                    </span>
                </div>
                <div className="card__text">
                    <p>{renderLastLogin()}</p>
                    <p>
                        {getText({ text: 'common.sessionDuration' })}: {sessionTime}
                    </p>
                </div>
                <div className="card__action" onClick={onClose}>
                    {buttonTitle}
                </div>
                <div className="card__footer">{footer}</div>
            </div>
        </div>
    );
};
